import { render, staticRenderFns } from "./VotingRightsCreate.vue?vue&type=template&id=30a74eea&scoped=true"
import script from "./VotingRightsCreate.vue?vue&type=script&lang=js"
export * from "./VotingRightsCreate.vue?vue&type=script&lang=js"
import style0 from "./VotingRightsCreate.vue?vue&type=style&index=0&id=30a74eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a74eea",
  null
  
)

export default component.exports